import { useCallback, useEffect, useState } from 'react';
import { analyticsService } from '../services/analyticsService';

export default function useInterveneOrgAgents(orgId) {
  const [agents, setAgents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const load = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await analyticsService.getInterveneAgents(orgId);
      const payload = res.data;
      const list = Array.isArray(payload?.agents)
        ? payload.agents
        : Array.isArray(payload?.data?.agents)
          ? payload.data.agents
          : [];
      setAgents(res.ok ? list : []);
    } catch {
      setAgents([]);
    } finally {
      setIsLoading(false);
    }
  }, [orgId]);

  useEffect(() => {
    load();
  }, [load]);

  return { agents, isLoading, reload: load };
}
